import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import SiteNav from "../components/site/SiteNav";
import SiteFooter from "../components/site/SiteFooter";
import { WalletCard, Strap, Wide, artFor } from "../components/TagArt";
import { useCart } from "../lib/site";

const CARDS = ["red", "white"].map(artFor);
const STRAPS = ["navy", "red"].map(artFor);
const WIDE = ["orange", "sky"].map(artFor);

function Buy({ id, colour, label }) {
  const { add } = useCart();
  const { isSignedIn } = useAuth();
  const nav = useNavigate();
  const go = () => { add(id, colour); toast.success(`${label} (${colour}) added to cart`); nav(isSignedIn ? "/app/checkout" : "/sign-up"); };
  return <button onClick={go} data-testid={`qrp-buy-${id}-${colour}`} className="mt-3 rounded-full bg-[#16294A] hover:bg-[#D7263D] text-white text-xs font-bold px-5 py-2.5 transition-colors">Buy {colour}</button>;
}

const Section = ({ title, children }) => <section className="mt-10"><div className="text-xs font-semibold tracking-[2px] text-[#3A4A5C] mb-4">{title}</div>{children}</section>;

export default function QRProducts() {
  return (
    <div className="landing min-h-screen text-[#16294A]" style={{ fontFamily: "Sora, sans-serif", background: "#E9EDF2" }} data-testid="qr-products-page">
      <SiteNav active="shop" />
      <main className="max-w-[1000px] mx-auto px-5 sm:px-8 py-10">
        <div className="text-xs text-slate-500"><Link to="/" className="underline">Home</Link> / <Link to="/shop" className="underline">Shop</Link> / Products with QR</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold">Products with QR</h1>
        <p className="mt-3 text-sm text-slate-600 max-w-xl">Every card and wristband has an NFC chip and a printed QR code. Tap with a phone or scan the code to open the emergency page.</p>
        <Section title="WALLET CARDS · NFC + QR"><div className="grid sm:grid-cols-2 gap-6">{CARDS.map((c) => <div key={c.colour}><WalletCard c={c} testid={`qrp-card-${c.colour}`} /><Buy id="id-card" colour={c.colour} label="Medical ID Card" /></div>)}</div></Section>
        <Section title="SNAP WRISTBANDS · NFC + QR (laid flat)"><div className="space-y-6">{STRAPS.map((s) => <div key={s.colour}><Strap s={s} testid={`qrp-strap-${s.colour}`} /><Buy id="snap-band" colour={s.colour} label="bsafe Snap Band" /></div>)}</div></Section>
        <Section title="WIDE SILICONE BANDS · NFC + QR"><div className="grid sm:grid-cols-2 gap-6">{WIDE.map((w) => <div key={w.colour}><Wide w={w} testid={`qrp-wide-${w.colour}`} /><Buy id="wide-band" colour={w.colour} label="bsafe Wide Band" /></div>)}</div></Section>
        <p className="mt-10 text-xs text-slate-500" data-testid="qrp-sample-note">QR codes shown are samples. Each real tag gets its own unique code linked to one profile.</p>
      </main>
      <SiteFooter />
    </div>
  );
}
